import { render, staticRenderFns } from "./ProductQRCode.vue?vue&type=template&id=15957b36&scoped=true"
import script from "./ProductQRCode.vue?vue&type=script&lang=js"
export * from "./ProductQRCode.vue?vue&type=script&lang=js"
import style0 from "./ProductQRCode.vue?vue&type=style&index=0&id=15957b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15957b36",
  null
  
)

export default component.exports